import { useNavigate } from "react-router-dom";

export default function SideMenu() {
  const nav = useNavigate();

  return (
    <>
      <div className="sideMenu">

        <div className="menuItem active" tabIndex="0" onClick={() => nav("/")}>
          <span>🏠</span>
          <p>Home</p>
        </div>

       

        <div className="menuItem" tabIndex="0">
          <span>📺</span>
          <p>Live TV</p>
        </div>

        <div
  className="menuItem"
  tabIndex="0"
  onClick={() => nav("/movies/netflix")}  // default
>
  <span>🎬</span>
  <p>Movies</p>
</div>

       <div 
  className="menuItem" 
  tabIndex="0"
  onClick={() => nav("/sports")}
>
  <span>🏏</span>
  <p>Sports</p>
</div>


        <div 
  className="menuItem" 
  tabIndex="0"
  onClick={() => nav("/ott")}
>
<span>🧩</span>
  <p>OTT Channels</p>
</div>


        <div className="menuItem" tabIndex="0">
          <span>📂</span>
          <p>Categories</p>
        </div>

        <div className="menuItem" tabIndex="0">
          <span>👤</span>
          <p>My Account</p>
        </div>

      </div>

      <style>{`
        .sideMenu {
          position: fixed;
          left: 0;
          top: 80px;
          height: calc(100vh - 80px);
          width: 60px;

          background: rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);

          display: flex;
          flex-direction: column;
          padding-top: 20px;
          transition: 0.4s ease;
          z-index: 1000;
        }

        /* AUTO EXPAND */
        .sideMenu:hover,
        .sideMenu:focus-within {
          width: 220px;
          background: rgba(0,0,0,0.55);
          backdrop-filter: blur(16px);
        }

        /* MENU ITEM */
        .menuItem {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 12px 18px;
          cursor: pointer;
          color: #ddd;
          transition: 0.25s;
          outline: none;
        }

        .menuItem span {
          font-size: 20px;
          min-width: 24px;
        }

        /* TEXT HIDE */
        .menuItem p {
          opacity: 0;
          white-space: nowrap;
          transition: 0.3s;
        }

        .sideMenu:hover .menuItem p,
        .sideMenu:focus-within .menuItem p {
          opacity: 1;
        }

        /* HOVER */
        .menuItem:hover {
          background: rgba(255,255,255,0.08);
          border-radius: 8px;
          color: #fff;
        }

        /* ACTIVE */
        .menuItem.active {
          background: rgba(255,255,255,0.15);
          border-radius: 8px;
          color: #fff;
        }

        /* TV REMOTE FOCUS */
        .menuItem:focus {
          background: rgba(229,9,20,0.25);
          border-radius: 8px;
          color: #fff;
          transform: scale(1.08);
          box-shadow:
            0 0 12px #e50914,
            0 0 30px rgba(229,9,20,0.6);
        }
      `}</style>
    </>
  );
}
